import { BASE_URL } from '../constants';

const setTeamResult = async (stream_key, entity_scores, is_draw, winner) => {
  try {
    const postData = {
      entity_scores,
      is_draw,
      winner,
    };

    const response = await fetch(
      `${BASE_URL}/api/v2/streams/${stream_key}/result`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(postData),
      },
    );

    const json = await response.json();

    if (json.error) {
      throw new Error(json.error.errorMessage);
    }

    return json;
  } catch (e) {
    throw new Error(e.message);
  }
};

export default setTeamResult;
